<div class="officeHome-callout officeHome-callout--arrowTop feature-tooltip ms-u-hiddenMdDown" aria-hidden="true" #featureTooltip>
    <div class="officeHome-callout-main">
        <div class="officeHome-callout-content feature-tooltip__content">
            <p class="officeHome-callout-subText" [innerHTML]="text"></p>
        </div>
    </div>
</div>